import { Select,Form, Space} from 'antd'
import React, { useEffect, useState } from 'react'
import {  useYhListQuery } from '../../store/BnsKeJiApi';
import ClientList from './ClientList';
function ClientSelect(props) {    
    const {data,isSuccess} = useYhListQuery({yh_xm_id:props.bxm_id},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);                
                const newArr = data.Result.map(item => {
                    const {yh_id:key,yh_name,} = item;
                    return item = {value:key,label:yh_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <Form.Item
            label={props.label}
            wrapperCol={props.wrapperCol}
            required={props.required}
            style={props.FormStyle}
        >
            <Space>
                <Form.Item
                    name={props.name}
                    style={{marginBottom:"0"}}
                >
                    <Select
                        options={list}
                        onChange={(e,f) => {props.onChange(e,f.label)}}
                        showSearch
                        optionFilterProp="label"
                        placeholder={props.placeholder}
                        style={props.style}
                    />
                </Form.Item>
                <ClientList bxm_id={props.bxm_id}  bxm_name={props.bxm_name}/>
            </Space>
        </Form.Item>
    )
}

export default ClientSelect
